import { render, staticRenderFns } from "./VideoMessage.vue?vue&type=template&id=315dc9ca&"
import script from "./VideoMessage.vue?vue&type=script&lang=js&"
export * from "./VideoMessage.vue?vue&type=script&lang=js&"
import style0 from "./VideoMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports